export default __webpack_public_path__ + "media/images/4-1fffc8c409c8aa2c47ab7f4faa6e8684.jpg";